export default __webpack_public_path__ + "static/media/successImage.7f09a93c.svg";